export default {
  props: {
    /**
     * The default image source (or fallback)
     *
     * {
     *    src: '',
     *    width: '',
     *    height: '',
     *    srcset: ''
     * }
     */
    image: {
      type: Object,
      required: true,
    },
    imgClass: {
      type: String,
      default: '',
    },
    /**
     * Alternate text for the image
     */
    alt: {
      type: String,
      default: '',
    },
    /**
     * Enable or disable lazy-loading
     */
    lazy: {
      type: Boolean,
      default: false,
    },
    /**
     * Add the optimized url-encoded `svg` as a placeholder
     */
    lazyPlaceholder: {
      type: Boolean,
      default: true,
    },
    sources: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },

  computed: {
    imgWidth() {
      return this.image.width ? this.image.width : this.width;
    },

    imgHeight() {
      return this.image.height ? this.image.height : this.height;
    },
  },

  methods: {
    /**
     * Provides an optimized url-encoded `svg` that's used to prevent content
     * reflow when images enter the viewport and are loaded.
     */
    placeholder(width, height) {
      return this.lazyPlaceholder
        ? `data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width=%22${width}%22%20height=%22${height}%22%20viewBox%3D%220%200%20${width}%20${height}%22%3E%3C%2Fsvg%3E`
        : null;
    },
  },
};
